import axios from 'axios';

function isLocalDevHost() {
  if (typeof window === 'undefined') {
    return false;
  }
  const host = window.location.hostname;
  return host === 'localhost' || host === '127.0.0.1';
}

function resolveApiBaseUrl() {
  const buildUrl = process.env.REACT_APP_API_BASE_URL || '';
  const fallback = 'http://localhost:8080';
  // 本地 npm start 时固定走本机后端，避免 runtime-config.js 里的公网地址干扰调试
  if (isLocalDevHost()) {
    return (buildUrl || fallback).replace(/\/+$/, '');
  }
  const runtimeUrl = window.__BAIXIAOSHENG_CONFIG__?.API_BASE_URL || '';
  return (runtimeUrl || buildUrl || fallback).replace(/\/+$/, '');
}

const apiBaseUrl = resolveApiBaseUrl();

export const api = axios.create({
  baseURL: apiBaseUrl,
  timeout: 10000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    if (!error.response) {
      const hint = error.code === 'ECONNABORTED'
        ? '请求超时'
        : '无法连接后端';
      error.adminMessage = `${hint}（${apiBaseUrl}）。请检查 runtime-config.js、HTTPS 证书与服务器防火墙。`;
    }
    return Promise.reject(error);
  }
);

export function getAdminErrorMessage(error, fallback = '操作失败') {
  return error?.adminMessage || error?.response?.data?.message || fallback;
}

export { apiBaseUrl };
